import React, { useEffect, useState, useContext } from "react";
import TextField from "@mui/material/TextField";
import InputLabel from "@mui/material/InputLabel";
import MenuItem from "@mui/material/MenuItem";
import FormControl from "@mui/material/FormControl";
import Select from "@mui/material/Select";
import "../../css/TemplateManger.scss";
import Autocomplete from "@mui/material/Autocomplete";
import { eDetail } from "../../utils/constants";
import { Button } from "react-bootstrap";
import BackArrowicon from "../../images/selectBox-dropdown.svg";
import ValueContext from "../../utils/contextAPI/contextAPI";
import "react-toastify/dist/ReactToastify.css";
import LibrarySearchIcon from "../../images/library-searchIcon.svg";
import { showErrorToast } from "../toastComponent/ToastComponent";

const SearchManager = ({
  setEDetailFields,
  eDetailFields,
  sendSearchDataToEdetails,
  type,
  setSearchClickEdetail,
  getEdetailList,
  showResults,
  showHeading,
  setShowHeading,
  market,
  brands,
  campaign,
  marketDataList,
  lastSearch,
  createdbyMe,
  setCreatedbyMe,
  setLastSearch,
  infinteScrollRef,
  expired,
  setExpired,
}) => {
  const appData = useContext(ValueContext);

  //const [searchTemplateFields, setSearchTemplateFields] = useState({});
  const [disabledResetBtn, setDisabledResetBtn] = useState(false);
  const [disabledSearchBtn, setDisabledSearchBtn] = useState(false);
  const [compaignData, setCampaignData] = useState([]);
  const [selectedMarket, setSelectedMarket] = useState("");
  const [customPlaceholder, setCustomPlaceholder] = useState(true);
  const [searchMetadata, setSearchMetadata] = useState({});

  useEffect(() => {
    /*  setEDetailFields({
       searchInput: "",
       brand: "",
       market: "",
       device: "",
       campaign: "",
     }); */
    // setSearchTemplateFields({
    //   searchInput: "",
    //   brand: "",
    //   market: "",
    //   device: "",
    //   campaign: "",
    // });
    setSearchMetadata({
      searchInput: "",
      brand: "",
      market: "",
      device: "",
      campaign: "",
    });
    setDisabledResetBtn(false);
  }, []);

  const resetEdetailFields = () => {
    infinteScrollRef?.current?.el?.scrollTo(0, 0);
    setCampaignData([]);
    setExpired(false);
    setSearchMetadata({
      searchInput: "",
      brand: "",
      market: "",
      device: "",
      campaign: "",
    });

    /* setEDetailFields({  //commented for preventing unwanted render on entering any metadata
      searchInput: "",
      brand: "",
      market: "",
      device: "",
      campaign: "",
    }); */
    // setSearchTemplateFields({
    //   searchInput: "",
    //   brand: "",
    //   market: "",
    //   device: "",
    //   campaign: "",
    // });

    setSelectedMarket("");
    setSearchClickEdetail(false);
    //we need to check for just one variable SearchClickEdetail
    setCreatedbyMe(true);
    // if (type === eDetail) {
    //   setSearchClickEdetail(false);
    //   setShowHeading({
    //     ...showHeading,
    //     edetailResHeader: `e-details (${showResults.length})`,
    //   });
    // } else {
    //   setSearchClicktemplate(false);
    //
    //   setShowHeading({
    //     ...showHeading,
    //     tempResheader: `Templates(${showTemplateRes.length})`,
    //   });
    // }
    setDisabledSearchBtn(false);
    setDisabledResetBtn(false);
    setCustomPlaceholder(true);
    sendSearchDataToEdetails("", "reset");
  };

  const handleChangesearchfields = (e, type) => {
    if (type === "searchInput") {
      if (e.target.value.trim().length > 0) {
        setCustomPlaceholder(false);
      } else {
        setCustomPlaceholder(true);
      }
    }

    if (e.target.value.trim().length > 0) {
      setDisabledSearchBtn(true);
      setDisabledResetBtn(true);
    } else if (
      /* e.target.value.trim().length === 0 &&
      // eDetailFields.searchInput.length === 0 &&
      eDetailFields.brand.length === 0 &&
      eDetailFields.market.length === 0 &&
      eDetailFields.device.length === 0 &&
      eDetailFields.campaign.length === 0 */

      e.target.value.trim().length === 0 &&
      // eDetailFields.searchInput.length === 0 &&
      searchMetadata.brand.length === 0 &&
      searchMetadata.market.length === 0 &&
      searchMetadata.device.length === 0 &&
      searchMetadata.campaign.length === 0
    ) {
      setDisabledSearchBtn(false);
    }

    if (type === "brand") {
      const filterdCampaign = brands.filter(
        (item) => item._id == e.target.value
      );
      setCampaignData(filterdCampaign[0].campaigns);
      const currentObj = {
        ...searchMetadata, //eDetailFields
        campaign: "",
        brand: e.target.value,
      };
      // setTempEdetails({ ...currentObj });
      //setEDetailFields({ ...currentObj });
      setSearchMetadata({ ...currentObj });
    //  console.log("current obj", currentObj, e.target.value);
      setDisabledSearchBtn(true);
      setDisabledResetBtn(true);
      return;
    }
    if (type === "device") {
      let currentObj = {
        ...searchMetadata, //eDetailFields
        device: {
          name: e.target.value,
          _id: appData.devices.filter((item) => item.name === e.target.value)[0]
            ._id,
        },
      };
      //setTempEdetails({ ...currentObj });
      setDisabledSearchBtn(true);
      setDisabledResetBtn(true);
      //setEDetailFields({ ...currentObj });
      setSearchMetadata({ ...currentObj });
      // setSearchTemplateFields(currentObj);
      return;
    }

    const name = e.target.name;
    //let tempSelected = { ...eDetailFields };
    let tempSelected = { ...searchMetadata };
    tempSelected[name] = e.target.value;
    //setTempEdetails(tempSelected);
    //setEDetailFields(tempSelected);
    setSearchMetadata(tempSelected);
    //  setSearchTemplateFields(tempSelected);

    if (
      lastSearch?.searchInput?.length > 0 &&
      lastSearch?.brand?.length > 0 &&
      lastSearch?.market?.length > 0 &&
      lastSearch?.device?.length > 0 &&
      lastSearch?.campaign?.length > 0
    ) {
      setDisabledResetBtn(false);
    } else {
      setDisabledResetBtn(true);
    }
  };

  const onClickedSearch = () => {
    // setEDetailFields(tempEdetails);

    infinteScrollRef?.current?.el?.scrollTo(0, 0);
    if (
      (searchMetadata.brand === "" &&
        searchMetadata.campaign === "" &&
        searchMetadata.market === "" &&
        searchMetadata.searchInput === "" &&
        searchMetadata.searchInput.trim() === "" &&
        searchMetadata.device === "") ||
      searchMetadata.device === undefined
    ) {
      showErrorToast('Please provide at least one input');
      return;
    }

    let marketID = marketDataList[market.indexOf(searchMetadata?.market)];

    let data = {
      searchInput: searchMetadata?.searchInput,
      brand: searchMetadata?.brand,
      device: searchMetadata?.device?._id,
      campaign: searchMetadata?.campaign,
      market: marketID === undefined ? "" : marketID._id,
      skip: 0,
      limit: 100,
      createdByMe: createdbyMe,
      expired: expired,
    };
    // console.log("payload for search", data);
    sendSearchDataToEdetails(data, "search");
    setLastSearch({
      searchInput: searchMetadata?.searchInput,
      brand: searchMetadata?.brand,
      device: searchMetadata?.device?._id,
      campaign: searchMetadata?.campaign,
      market: marketID === undefined ? "" : marketID._id,
    });
  };

  const handleOnEnter = (e) => {
    if (e.key === "Enter") {
      onClickedSearch();
      /* if (searchTemplateFields.searchInput !== "") {
        let marketID = marketDataList[market.indexOf(eDetailFields?.market)];
  
        let data = {
          searchInput: eDetailFields?.searchInput,
          brand: eDetailFields?.brand,
          device: eDetailFields?.device?._id,
          campaign: eDetailFields?.campaign,
          market: marketID === undefined ? "" : marketID._id,
          createdByMe: createdbyMe
        };
        console.log('payload for search', data)
        sendSearchDataToEdetails(data, "search");
      } else {
        sendSearchDataToEdetails("", "reset");
      } */
    }
  };
  const handleMarketChange = (e, newValue) => {
    if (newValue) {
      // setSelectedMarket(newValue);
      /* setEDetailFields({
        ...eDetailFields,
        market: newValue,
      }); */
      setSearchMetadata({
        ...searchMetadata,
        market: newValue,
      });
      // setSearchTemplateFields({ ...searchTemplateFields, market: newValue });
      setDisabledSearchBtn(true);
      setDisabledResetBtn(true);
    } else {
      //setSelectedMarket("");
      /* setEDetailFields({
        ...eDetailFields,
        market: "",
      }); */
      setSearchMetadata({
        ...searchMetadata,
        market: "",
      });
      // setSearchTemplateFields({ ...searchTemplateFields, market: "" });
      setDisabledResetBtn(false);
    }
  };
  // const fetchMarketData = () => {
  //   // docClient.scan(params, function (err, data) {
  //   getMarketList((response, err, errorCode) => {
  //     if (err) {
  //     } else {
  //       const countriesList = response.data.result.countries;
  //       let marketData = [];
  //       countriesList.forEach((item) => marketData.push(item.name));
  //       setMarketDataList(marketData);
  //     }
  //   });
  // };
  // useEffect(() => {
  //   fetchMarketData();
  // }, []);
  const handleCustomPlaceholder = () => {
    document.querySelector("#global-search-module").focus();
  };

  return (
    <div className="row g-0">
      <div className="col-md-12 g-0">
        <div className="searchBorderBtm">
          <div className="row g-0">
            <div className="col-md-12 g-0">
              <div className="d-flex g-0 template-searchRow">
                {/* <SearchIcon /> */}
                <img
                  alt="search"
                  src={LibrarySearchIcon}
                  className={"searchManagerIcon"}
                ></img>
                {customPlaceholder && (
                  <div
                    className="customSearchHolder"
                    onClick={handleCustomPlaceholder}
                  >
                    Search by{" "}
                    <span>
                      {type === eDetail
                        ? `‘e-Detail name / ID’`
                        : `‘Template name / ID’`}
                    </span>
                  </div>
                )}
                <input
                  value={searchMetadata?.searchInput}
                  id="global-search-module"
                  type="text"
                  name="searchInput"
                  /* placeholder={
                    type === eDetail
                      ? `Search by ‘e-Detail name / ID’`
                      : "Search by 'Template name / ID'"
                  } */
                  className="globalSearchInputNav"
                  onChange={(e) => handleChangesearchfields(e, "searchInput")}
                  autoComplete="off"
                  onKeyDown={handleOnEnter}
                  autoFocus
                //  onKeyPress={handleEnterKeypress}
                />
              </div>
            </div>
          </div>
          <div className="row basedonBrand">
            <div className="col-md-2 searchFieldlabel">
              <FormControl size="small" fullWidth className="FormControl">
                <InputLabel
                  id="demo-simple-select-label"
                  style={{
                    fontSize: "12px",
                    transformOrigin: "top",
                    color: "#66676b",
                    position: "absolute",
                  }}
                >
                  Product
                </InputLabel>
                <Select
                  labelId="demo-select-small"
                  id="demo-select-small"
                  className="MUI-selectbox-customChng"
                  value={searchMetadata?.brand || ""}
                  label="Product"//"Brand"
                  onChange={(e) => handleChangesearchfields(e, "brand")}
                  name="brand"
                  style={{
                    fontSize: "12px",
                    color: "#231f20",
                    fontWeight: "600",
                    padding: "5px 0 0 0",
                    letterSpacing: "0.12px",
                  }}
                  MenuProps={{
                    style: {
                      maxHeight: 400,
                    },
                  }}
                >
                  {brands &&
                    brands.length > 0 &&
                    brands.map((item) => {
                      return (
                        <MenuItem
                          value={item?._id}
                          id={item._id}
                          key={item._id}
                        >
                          {item?.name}
                        </MenuItem>
                      );
                    })}
                </Select>
              </FormControl>
            </div>
            <div className="col-md-2 marketFieldSearch">
              <Autocomplete
                disableClearable
                //popupIcon={<BackArrowicon />}
                popupIcon={<img src={BackArrowicon} alt="" />}
                id="combo-box-demo"
                className="MUI-selectbox-customChng"
                options={market}
                value={searchMetadata?.market || ""}
                onChange={(e, newValue) => handleMarketChange(e, newValue)}
                fullWidth={true}
                size="small"
                sx={{
                  "& .MuiAutocomplete-input, & .MuiInputLabel-root": {
                    fontSize: "12px",
                  },
                }}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    label="Country"//"Market"
                    name="market"
                    id="demo-select-small"
                    className="MUI-selectbox-customChng"
                  // InputProps={{
                  //   ...params.InputProps,
                  //   endAdornment: (
                  //     <span className="contract-search-icon">
                  //       <img
                  //         src={BackArrowicon}
                  //         alt=""
                  //         className="arrowicon"
                  //       />
                  //     </span>
                  //   ),
                  // }}
                  // onChange={({ target }) => setSelectedMarket(target.value)}
                  />
                )}
              />
            </div>
            {/* <div className="col-md-2"></div> */}
            <div className="col-md-2 searchFieldlabel">
              <FormControl fullWidth className="FormControl" size="small">
                <InputLabel
                  id="demo-simple-select-label"
                  style={{
                    fontSize: "12px",
                    transformOrigin: "top",
                    color: "#66676b",
                    position: "absolute",
                  }}
                >
                  Device
                </InputLabel>
                <Select
                  labelId="demo-select-small"
                  id="demo-select-small"
                  className="MUI-selectbox-customChng"
                  value={searchMetadata?.device?.name || ""}
                  label="Device"
                  onChange={(e) => handleChangesearchfields(e, "device")}
                  name="device"
                  style={{
                    fontSize: "12px",
                    color: "#231f20",
                    fontWeight: "600",
                    padding: "5px 0 0 0",
                    letterSpacing: "0.12px",
                  }}
                >
                  {appData.devices.map((device) => (
                    <MenuItem value={device.name}>{device.name}</MenuItem>
                  ))}
                  {/* <MenuItem value="Ipad">Ipad</MenuItem>
                  <MenuItem value="Desktop">Desktop</MenuItem>
                  <MenuItem value="Laptop">Laptop</MenuItem> */}
                </Select>
              </FormControl>
            </div>
            <div className="col-md-6 searchFieldlabel campaignFeild">
              <div class="d-flex">
                <FormControl fullWidth className="FormControl" size="small">
                  <InputLabel
                    id="demo-simple-select-label"
                    style={{
                      fontSize: "12px",
                      transformOrigin: "top",
                      color: "#66676b",
                      position: "absolute",
                    }}
                  >
                    Campaign
                  </InputLabel>
                  <Select
                    labelId="demo-select-small"
                    id="demo-select-small"
                    className="MUI-selectbox-customChng"
                    value={searchMetadata?.campaign}
                    label="campaign"
                    onChange={(e) => handleChangesearchfields(e, "campaign")}
                    name="campaign"
                    style={{
                      fontSize: "12px",
                      color: "#231f20",
                      fontWeight: "600",
                      padding: "5px 0 0 0",
                      letterSpacing: "0.12px",
                    }}
                  >
                    {compaignData &&
                      compaignData.length > 0 &&
                      compaignData.map((item) => {
                        return (
                          <MenuItem
                            value={item?._id}
                            id={item._id}
                            key={item._id}
                          >
                            {item?.name}
                          </MenuItem>
                        );
                      })}
                  </Select>
                </FormControl>

                <div className="flex-col-fixed searchTemplatebtn">
                  <Button
                    className={`btn serachbtnPrimary`}
                    disabled={!disabledSearchBtn}
                    onClick={onClickedSearch}
                  >
                    SEARCH
                  </Button>
                  <Button
                    className={`btn btn-link reset-button reset-text ${disabledResetBtn
                      ? "disabled-reset-button"
                      : "enabled-reset-button"
                      }`}
                    disabled={!disabledResetBtn}
                    onClick={() => {
                      resetEdetailFields();
                    }}
                  >
                    RESET ALL
                  </Button>
                </div>
              </div>
            </div>
            {/* <div className="col-md-1 resetTemplatebtn"></div> */}
          </div>
        </div>
      </div>
    </div>
  );
};

export default SearchManager;
